var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.42 31.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d,.e{fill:none;}.f{fill:#ffaa50;}.e{stroke:#7c1902;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.32px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M15.71,29.71c7.73,0,14-6.27,14-14S23.44,1.71,15.71,1.71,1.71,7.98,1.71,15.71s6.27,14,14,14"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.73,4.94c1.29,0,2.09,1.04,1.79,2.33l-.27,1.17h-4.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M15.25,24.16l.14-.58H1.99l-.14,.58c-.3,1.29,.5,2.33,1.79,2.33h13.4c-1.29,0-2.09-1.04-1.79-2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M6.45,10.18c5.55,4.07,9.74,8.58,10.49,11.07l-3.5-1.17s-.49-1.02-.76-1.35c-2.6,.21-2.82-.94-2.75-1.77-1.61-.5-2.83-1.43-4.18-2.85-2.17-2.28-3.68-5.76-2.87-9.18,1.15,1.56,3.34,2.78,5.54,3.69,3.86,1.6,6.26,3.4,6.25,5.56,1.58,1.05,1.69,1.72,1.43,2.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M9.4,6.98c.81-1.48,1.73-2.04,2.88-2.04h14.46c-1.29,0-2.58,1.08-3.39,2.91-1.2,2.69-1.24,13.14-2.91,16.31-.99,1.87-2.11,2.33-3.39,2.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M6.23,23.58c.53-1.37,.87-3.52,1.15-5.83"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 31.42,
    height: 31.42
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.4114d48e51e8f7ed02fd81004d0b6ad4.svg";
export { ForwardRef as ReactComponent };